export default __webpack_public_path__ + "static/media/afiliados.ad4e8593.png";